export default __webpack_public_path__ + "static/media/mTop_1_p1.3d62079a.jpeg";